export const formatEnum = (value) => {
  if (!value) return "";

  const map = {
    ALTIN_ALINDI: "Altın Alındı",
    ALTIN_VERILDI: "Altın Verildi",
    NAKIT_ALINDI: "Nakit Alındı",
    NAKIT_VERILDI: "Nakit Verildi",
    ZIYNET_ALINDI: "Ziynet Alındı",
    ZIYNET_VERILDI: "Ziynet Verildi",
    NAKIT_ISLEM_GRAM_ALINDI: "(Gr) Nakit Alındı",
    NAKIT_ISLEM_GRAM_VERILDI: "(Gr) Nakit Verildi",
  };

  return map[value] || value;
};
